import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { ApiClient } from '../api/api-client';

export default function ProtectedRoute() {
  const [auth, loggedIn] = useState(null);
  const location = useLocation();

  useEffect(() => {
    ApiClient.getInstance()
      .getSession()
      .then((res) => {
        const isSystem = res.data.systemAccount === true;
        if (isSystem) {
          loggedIn(false);
          sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
        } else {
          loggedIn(true);
          sessionStorage.setItem('userId', res.data.id);
          sessionStorage.setItem('username', res.data.name);
          sessionStorage.setItem('systemAccount', 'false');
        }
      })
      .catch(() => {
        loggedIn(false);
        sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
      } );
  }, []);
  if (auth === null) return <div> </div>;
  
  if (auth === false) return <Navigate to="/" replace />;
  return <Outlet />;
}